<template>
  <div class="pa-3">
    <v-row>
      <v-col cols="6" offset="3" align="center">
        <k-influencer-search-box :search="peformSearch" :page="currentPage" :limit="pagination.itemsPerPage" :sortBy="pagination.sortBy[0]" :descending="pagination.sortDesc[0]" @result="searchDone"></k-influencer-search-box>
      </v-col>
      <v-col cols="6" offset="3" align="center">
        <v-btn color="success" @click="searchByKeywords">Search</v-btn>
      </v-col>
    </v-row>
    <div class="row">
      <div class="col-xs-12">
        <button
          id="viewReport"
          style="display: none"
          data-toggle="modal"
          :data-target="audienceDataReportDisplay"
        ></button>
        <button
          id="viewPosts"
          style="display: none"
          data-toggle="modal"
          :data-target="influencerPostDisplay"
        ></button>
        <table class="summary" v-if="summary">
          <tr>
            <th></th>
            <th>Count</th>
            <th>Total Outreach</th>
            <th>Average Engagement</th>
          </tr>
          <tr>
            <th>High-tier</th>
            <th>{{summary.hightier.count}}</th>
            <th>{{Number(summary.hightier.total_outreach).toLocaleString()}}</th>
            <th>{{summary.hightier.average_engagement}}%</th>
          </tr>
          <tr>
            <th>Everyday</th>
            <th>{{summary.everyday.count}}</th>
            <th>{{Number(summary.everyday.total_outreach).toLocaleString()}}</th>
            <th>{{summary.everyday.average_engagement}}%</th>
          </tr>
        </table>
        <v-row class="row mb-1" style="margin-top:10px;">
          <v-col xs="12" sm="2" md="2" lg="2">
            <v-btn-toggle v-model="display" mandatory :value="0" :light="true">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on">
                    <v-icon>grid_on</v-icon>
                  </v-btn>
                </template>
                <span>Card View</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on">
                    <v-icon>list</v-icon>
                  </v-btn>
                </template>
                <span>List View</span>
              </v-tooltip>
            </v-btn-toggle>
          </v-col>
        </v-row>
        <div v-if="display === 0">
          <v-row style="margin-top:10px;margin-bottom:10px;" class="no-gutters">
            <v-col v-for="post of igPostItems" :key="post.id" cols="auto" sm="12" md="4" lg="4" class="pa-2">
              <v-card
                class="mx-auto campaign-post"
                color="#62727b"
                dark
                max-width="400"
                :elevation="2"
              >
                <v-card-title>
                  <!-- <v-list-item class="grow pa-0">
                    <v-list-item-avatar color="grey darken-3">
                      <v-img class="elevation-6" :src="post.profilePicture"></v-img>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title>
                        <a class="caption" :href="'https://instagram.com/' + post.instagramHandle" target="_blank"
                          >@{{ post.instagramHandle }}</a
                        >
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item> -->
                  <v-chip
                    label
                    color="green"
                    small
                    v-for="tag of post.tags"
                    v-bind:key="tag"
                    text-color="white"
                    class="mr-2"
                  >
                    <v-icon float-left>label</v-icon>
                    {{tag}}
                  </v-chip>
                </v-card-title>
                <v-card-text class="headline font-weight-bold" style="min-height:560px">
                  <!-- <img
                    width="100%"
                    class="elevation-0"
                    :src="post.media_url ? post.media_url : post.post_details.image"
                  /> -->
                  <div class="content-igPost-block" style="max-width:350px;" v-html="post.igPost" v-if="post.igPost"></div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <div class="ma-5">
            <v-row>
              <v-col cols="12">
                <v-pagination
                  v-model="pagination.page"
                  circle
                  @input="cardSearchByKeywords()"
                  :value="pagination.page"
                  :length="paginationLength"
                  :total-visible="7"
                ></v-pagination>
              </v-col>
            </v-row>
          </div>
        </div>
        <div v-if="display === 1">
          <v-data-table
            :headers="fields"
            :items="items"
            :options.sync="pagination"
            :footer-props="{
              itemsPerPageOptions: rowsPerPageItems
            }"
            :server-items-length="totalItems"
            item-key="instagramHandle"
          >
            <template v-slot:body="{items}">
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td class="text-xs-left">
                    <v-avatar :size="avatarSize" color="grey lighten-4">
                      <img v-bind:src="item.profilePicture" alt="avatar" />
                    </v-avatar>
                  </td>
                  <td class="text-xs-left">
                    <a
                      target="_blank"
                      v-bind:href="'https://instagram.com/' + item.instagramHandle"
                    >@{{ item.instagramHandle }}</a>
                  </td>
                  <td class="text-xs-left">{{ item.totalFollowers }}</td>
                  <td class="text-xs-left">{{ item.engagementRate }}%</td>
                  <td class="text-xs-left">{{ item.audienceCredibility }}%</td>
                  <td class="text-xs-left">{{ item.relevancyScore }}</td>
                  <td class="text-xs-left">
                    <v-chip
                      label
                      color="green"
                      small
                      v-for="tag of item.tags"
                      v-bind:key="tag"
                      text-color="white"
                    >
                      <v-icon float-left>label</v-icon>
                      {{tag}}
                    </v-chip>
                  </td>
                  <td class="text-xs-left">
                    {{ item.postCreatedDate }}
                  </td>
                  <td class="justify-center layout px-0">
                    <!-- View audience data -->
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          medium
                          class="mr-2"
                          v-on="on"
                          color="success"
                          @click.stop="showReport(item)"
                        >assessment</v-icon>
                      </template>
                      <span>View Audience Data</span>
                    </v-tooltip>
                    <!-- Show influencer popular posts -->
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          medium
                          class="mr-2"
                          v-on="on"
                          color="success"
                          @click.stop="viewInfluencerPosts(item)"
                        >local_library</v-icon>
                      </template>
                      <span>View Posts</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </div>
      </div>
    </div>
    <!-- Audience data report modal -->
    <audience-data-report-modal
      v-model="viewAudienceDataDialog"
      :audienceData="audienceDataReport"
    />

    <!-- loading -->
    <v-dialog v-model="loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- View Influencer post -->
    <influencer-post-modal
      :modalId="influencerPostModalId"
      :title="postsTitle"
      :shortCodes="shortCodes"
    />
  </div>
</template>
<script>
import moment from 'moment';
import config from '@/config';
import utils from '../../../utils';
import influencerAPIs from './influencerAPIs';
import igPostAnalys from '../ContentAnalysis/contentAnalysisAPI'
import AudienceDataReportModal from './AudienceDataReportModal';
import InfluencerPostModal from './InfluencerPostsModal';
import KInfluencerSearchBox from '../../scoped/influencer/InfluencerSearchBox';
export default {
  name: 'SearchKeyword',
  components: {
    AudienceDataReportModal,
    InfluencerPostModal,
    KInfluencerSearchBox
  },
  data() {
    return {
      audienceDataReportId: 'audience_data_report_modal',
      influencerPostModalId: 'influencerPostModalId',
      viewAudienceDataDialog: false,
      viewInfluencerData: null,
      audienceDataReport: null,
      expand: false, // Close other rows
      loading: false,
      peformSearch: 'none',
      pagination: {
        page: 1,
        itemsPerPage: 50,
        sortBy: ['postCreatedDate'],
        sortDesc: [true]
      },
      totalItems: 0,
      rowsPerPageItems: [10, 20, 50, 100],
      originalItems: [],
      postsTitle: '',
      avatarSize: 45, // avatar
      shortCodes: [],
      fields: [
        {
          text: 'Avatar',
          value: 'profilePicture',
          sortable: false
        },
        {
          value: 'instagramHandle',
          text: 'Handle',
          sortable: false
        },
        {
          value: 'totalFollowers',
          text: 'Followers',
          sortable: true
        },
        {
          value: 'engagementRate',
          text: 'Engagement Rate',
          sortable: true,
          width: '60px'
        },
        {
          value: 'audienceCredibility',
          text: 'Audience Credibility',
          sortable: true,
          width: '60px'
        },
        {
          value: 'relevancyScore',
          text: 'Relevancy Score',
          sortable: true
        },
        {
          value: 'tag',
          text: 'Tag',
          sortable: false
        },
        {
          value: 'postCreatedDate',
          text: 'Post Created Date',
          sortable: true
        },
        {
          value: 'action',
          text: 'Actions',
          sortable: false
        }
      ],
      items: [],
      igPostItems: [],
      summary: null,
      lastUpdate: null,
      totalRows: 0,
      currentPage: 1,
      perPage: 15,
      filGender: 'Any',
      igHandle: '',
      searchedItems: [],
      resultMessage: '',
      display: 1
    };
  },
  computed: {
    currentUserRole: function() {
      return Number(this.$store.state.user.role);
    },
    updatedOn: function() {
      return moment(this.lastUpdate).fromNow();
    },
    audienceDataReportDisplay: function() {
      return '#' + this.audienceDataReportId;
    },
    influencerPostDisplay: function() {
      return '#' + this.influencerPostModalId;
    },
    paginationLength: function() {
      let round = this.totalItems / this.pagination.itemsPerPage;
      let decimal = this.totalItems % this.pagination.itemsPerPage;
      return Math.floor(round) + (decimal === 0 ? 0 : 1) || 1;
    }
  },
  watch: {
    pagination() {
      if (this.peformSearch !== 'none') {
        this.currentPage = this.pagination.page
        this.searchByKeywords()
      }
    },
    display(newVal) {
      if (newVal === 0) {
        this.cardSearchByKeywords()
      }
    }
  },
  methods: {
    searchByKeywords() {
      this.items = []
      // this.pagination.page = 1
      // this.currentPage = 1
      this.loading = true
      this.peformSearch = utils.func.makeid(5);
    },
    cardSearchByKeywords() {
      this.display = 0
      this.items = []
      // this.pagination.page = 1
      // this.currentPage = 1
      this.loading = true
      this.currentPage = this.pagination.page
      this.peformSearch = utils.func.makeid(5);
    },
    searchDone(value) {
      this.loading = false
      if (value.success) {
        this.items = Object.assign([], value.originalItems)
        this.success = value.summary
        this.totalItems = value.totalItems
        this.paginate()
      } else {
        if (value.nokeyword) {
          // if no keyword alert, do nth
        } else {
          this.$swal({
            title: 'Could not load data',
            text: 'Oop!! There are something wrong',
            type: 'error'
          });
        }
      }
    },
    buttonShow(type) {
      const roleAllow = config['userPermissions']['influencer'][type];
      return roleAllow ? roleAllow.includes(this.currentUserRole) : false;
    },
    paginate() {
      let { page } = this.pagination;
      this.currentPage = page
      // if (sortBy.length === 1 && sortDesc.length === 1) {
      //   this.sort(sortBy[0], sortDesc[0]);
      // }
      // let items = this.originalItems.slice((page - 1) * itemsPerPage, itemsPerPage * page);
      this.updateItems(this.items);
      this.paserImageUrl()
      if (this.display === 0) {
        this.getInstagramPost()
      }
    },
    sort(sortBy, descending) {
      let sortCriteria = '';
      switch (sortBy) {
        case 'totalFollowers':
          sortCriteria = 'instagram.totalFollowers';
          break;
        case 'engagementRate':
          sortCriteria = 'audience.user_profile.engagement_rate';
          break;
        case 'audienceCredibility':
          sortCriteria = 'audience.audience_followers.data.audience_credibility';
          break;
        case 'relevancyScore':
          sortCriteria = 'relevancyScore';
          break;
        default:
          sortCriteria = 'relevancyScore';
      }
      this.items.sort((a, b) => {
        let prev = this.getValueByPath(a, sortCriteria);
        let last = this.getValueByPath(b, sortCriteria);
        if (descending) {
          return last > prev ? 1 : last < prev ? -1 : 0;
        }
        return last > prev ? -1 : last > prev ? 1 : 0;
      });
    },
    getValueByPath(obj, path) {
      let val = obj;
      let paths = path.split('.');
      paths.forEach(p => {
        if (val) val = val[p];
      });
      return Number(val || 0);
    },
    updateItems(response) {
      const displayItems = response.map(element =>
        Object.assign(
          { id: element.id },
          {
            instagramHandle: element.instagram ? element.instagram.instagramHandle : null,
            instagramID: element.instagram ? element.instagram.instagramID : null,
            instagramFullname: element.fullName || element.instagram ? element.instagram.instagramFullname : null,
            totalFollowers: element.instagram ? element.instagram.totalFollowers : 0,
            totalFollowing: element.instagram ? element.instagram.totalFollowing : 0,
            joinedAt: this.formatTime(element.createdAt),
            posts: element.posts || [],
            audience: element.audience || {},
            profilePicture:
              element.audience && element.audience.user_profile
                ? element.audience.user_profile.picture || '/static/img/avatar/user.png'
                : '/static/img/avatar/user.png',
            instagram: element.instagram || {},
            gender: element.gender,
            birthday: element.birthday || 'None',
            email: element.email || 'None',
            mailingAddress: element.mailingAddress || 'None',
            bankAccount: element.bankAccount || 'None',
            bankName: element.bankName || 'None',
            country: element.country || 'None',
            relevancyScore: element.relevancyScore,
            tags: element.keywords || [],
            engagementRate:
              element.audience && element.audience.user_profile
                ? (Number(element.audience.user_profile.engagement_rate) * 100).toFixed(2)
                : 0,
            audienceCredibility:
              element.audience && element.audience.audience_followers
                ? Number(element.audience.audience_followers.data.audience_credibility * 100).toFixed(2)
                : 0,
            postCreatedDate: element.post_information ? this.formatPostTime(element.post_information.post_created_time) : '',
            postShortCode: element.posts ? element.posts[0].shortCode : ''
          }
        )
      );
      this.items = []
      displayItems.map(d => {
        let exists = this.items.find(ig => ig.postShortCode === d.postShortCode)
        if (!exists) {
          this.items.push(d)
        }
      })
      this.totalRows = response.totalInfluencers;
      // store the searched results for Filtering
      this.searchedItems = displayItems;
    },
    viewInfluencerPosts(item) {
      let posts = item.posts || [];
      if (posts.length > 0) {
        this.shortCodes = posts.map(item => item.shortCode);
        document.getElementById('viewPosts').click();
        this.postsTitle = `Related Posts(${item.instagramHandle})`;
      } else {
        this.$swal({
          title: 'Empty',
          text: 'Oop!! There are no posts',
          type: 'info'
        });
      }
    },
    showReport(influencer) {
      this.loading = true;
      influencerAPIs
        .fetchLocalAudienceReport(null, influencer.instagramID, influencer.instagramHandle)
        .then(resp => {
          this.audienceDataReport = resp.data;
          // document.getElementById('viewReport').click();
          this.viewAudienceDataDialog = true;
          this.loading = false;
        })
        .catch(err => {
          console.error(err);
          this.loading = false;
        });
    },
    exportInfluencers() {
      influencerAPIs
        .exportAllInfluencers()
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `influencers_${moment().format('X')}.csv`);
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          console.log(error);
        });
    },
    formatTime(value) {
      return moment(value).format('YYYY-MM-DD hh:mm:ss');
    },
    formatPostTime(value) {
      // value = String(value)
      // if (value.length < 13) {
      //   while (value.length < 13) {
      //     value += 0
      //   }
      // }
      return moment(parseInt(value)).format('DD-MM-YYYY')
    },
    async paserImageUrl() {
      for (let item of this.items) {
        try {
          await fetch(item.profilePicture)
        } catch (err) {
          // if img failed, set default img
          console.error(err)
          item.profilePicture = '/static/img/avatar/user.png'
        }
      }
    },
    async getInstagramPost() {
      this.loading = true
      this.igPostItems = []
      for (let item of this.items) {
        if (item.posts.length) {
          let post = item.posts[0]
          let shortCode = post.shortCode
          let data = await igPostAnalys.oembed(shortCode);
          setTimeout(() => {
            window.instgrm.Embeds.process()
          }, 100)
          item.igPost = data.oembed
          if (item.igPost) {
            let exists = this.igPostItems.find(ig => ig.postShortCode === shortCode)
            if (!exists) {
              this.igPostItems.push(item)
            }
          }
        }
      }
      this.loading = false
    }
  },
  created() {}
};
</script>

<style>
#ig-handle {
  cursor: pointer;
}
.engagement {
  color: #81bee2;
  font-size: 20px;
}
.v-dialog-wrapper {
  margin-top: 24px !important;
  padding: 0px;
}
.summary {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 500px;
  margin: auto;
  margin-bottom: 15px;
  margin-top: 15px;
}

.summary td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

.content-igPost-block {
  overflow: scroll;
  max-width: 350px;
  max-height: 560px;
}
</style>



// WEBPACK FOOTER //
// SearchKeyword.vue?142ec6b8